import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const LiveTab = () => {
  const { courseId } = useSelector(state => state.courseHome);
  const liveModel = useSelector(state => state.models.live);
  useEffect(() => {
    const iframe = document.getElementById('lti-tab-embed');
    if (iframe) {
      iframe.classList.add('notranslate', 'vh-100', 'w-100', 'border-0');
      iframe.setAttribute('translate', 'no');
    }
  }, []);
  return (
    <div
      className="notranslate"
      id="live_tab"
      translate="no"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: liveModel[courseId]?.iframe }}
    />
  );
};

export default LiveTab;
